import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetCoFoundersList = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.fundraising.co_founders_list],
    queryFn: () =>
      fundraisingService.coFoundersList().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
